/**
 * Centraliza la construcción de URLs de la API.
 * La variable de entorno VITE_API_BASE_URL debe contener SOLO el host
 * (p. ej. http://localhost:4800). El prefijo de versión se construye aquí
 * para poder convivir con futuras versiones (v2, v3, ...).
 */

export const API_V1_PREFIX = '/api/v1';

function normalizeHost(url: string): string {
  if (!url || typeof url !== 'string') return '';
  let trimmed = url.trim().replace(/\/+$/, '');
  if (!trimmed) return '';
  if (!trimmed.startsWith('http://') && !trimmed.startsWith('https://')) {
    trimmed = `http://${trimmed}`;
  }
  return trimmed;
}

export function getApiHost(): string {
  const raw =
    import.meta.env.VITE_API_BASE_URL ||
    import.meta.env.VITE_PUBLIC_API_URL ||
    'http://localhost:4800';
  return normalizeHost(String(raw));
}

export function getApiV1BaseURL(): string {
  // En dev usamos ruta relativa para que pase por el proxy de Vite
  // (vite.config.ts → server.proxy['/api']). Esto evita CORS y el bloqueo
  // de mixed content cuando el front corre en HTTPS y la API en HTTP.
  if (import.meta.env.DEV) {
    return API_V1_PREFIX;
  }
  return `${getApiHost()}${API_V1_PREFIX}`;
}

/**
 * Returns the base URL for browser-facing resources (iframe src, img src, download hrefs).
 * - In development: returns `/api/v1` (relative, goes through Vite proxy)
 * - In production: returns full URL like `https://mishiwoof-api.onrender.com/api/v1`
 */
export function getApiV1Path(): string {
  if (import.meta.env.DEV) {
    return API_V1_PREFIX;
  }
  return getApiV1BaseURL();
}
